import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";

const TermsAndConditions = () => {
  return (
    <>
      <Meta title={"Terms and Conditions"} />
      <BreadCrumb title="Terms and Conditions" />
      <Container className="policy-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <div className="policy">
              <h2>Terms & Conditions</h2>
              <p>
                This document is an electronic record in terms of the Information Technology Act, 2000 
                and the rules thereunder. This electronic record is generated by a computer system and 
                does not require any physical or digital signatures.
              </p>
              <p>
                This document is published in accordance with the provisions of Rule 3 (1) of the 
                Information Technology (Intermediaries Guidelines) Rules, 2011 that require publishing 
                the rules and regulations, privacy policy, and Terms of Use for access or usage of the 
                domain name <a href="https://softechsystems.in/">https://softechsystems.in/</a> 
                (referred to as "Platform").
              </p>

              <p>
                The Platform is owned by <strong>SOFTECH</strong>, a company incorporated under the Companies Act, 1956, 
                with its registered office at 1st Floor, 28, M D Arced, Opp Canara Bank, 6th Cross, HMT, 
                Main Road, Mathikere, Bangalore, India (referred to as "Platform Owner", "we", "us", "our").
              </p>

              <h3>1. Acceptance of Terms</h3>
              <p>
                By accessing, browsing, or using the Platform, you agree to all the terms and conditions 
                outlined in these Terms of Use.
              </p>

              <h3>2. User Responsibilities</h3>
              <ul>
                <li>You agree to provide accurate and complete information during registration.</li>
                <li>You will be responsible for all activities under your registered account.</li>
              </ul>

              <h3>3. Warranty Disclaimer</h3>
              <p>
                Neither we nor any third parties provide any warranty or guarantee as to the accuracy, 
                timeliness, performance, completeness, or suitability of the information and materials 
                offered on this Platform for any specific purpose. 
              </p>

              <h3>4. Intellectual Property</h3>
              <p>
                The contents of the Platform, including design, layout, look, and graphics, are proprietary 
                to us and licensed to us. You shall not have any intellectual property rights over the content.
              </p>

              <h3>5. Limitation of Liability</h3>
              <p>
                Your use of the Platform and Services is at your own risk. We shall not be liable for any 
                direct, indirect, incidental, or consequential damages.
              </p>

              <h3>6. Indemnity</h3>
              <p>
                You agree to indemnify and hold harmless the Platform Owner, its affiliates, group companies, 
                and their respective officers, directors, agents, and employees from any claim or demand due 
                to your breach of these Terms.
              </p>

              <h3>7. Governing Law and Jurisdiction</h3>
              <p>
                These Terms are governed by the laws of India. All disputes arising out of these Terms shall be 
                subject to the exclusive jurisdiction of the courts in Bangalore, Karnataka.
              </p>

              <h3>8. Modification of Terms</h3>
              <p>
                We reserve the right to modify these Terms at any time without prior notice. Your continued use 
                of the Platform indicates acceptance of any modified terms.
              </p>

              <h3>9. Contact Information</h3>
              <p>
                All concerns or communications related to these Terms must be directed to us using the contact 
                information provided on the website.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default TermsAndConditions;
